import { StyleSheet, Platform, Dimensions } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  billingPaymentView: {
    marginTop: 45,
    marginBottom: 30,
  },
  billingValueTextStyle: theme => ({
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.textColorThree,
    fontSize: 40,
    alignSelf: 'center',
    marginVertical: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 20 : 0
  }),
  billingValueSubTextStyle: theme => ({
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.textColorThree,
    fontSize: 23.3,
    alignSelf: 'center',
  }),
  topupValueView: {
    marginVertical: 100,
  },
  valueWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%'
  },
  value: (theme, isValidTopupNumber) => {
    return ({
      width: '140px',
      height: '80px',
      padding: '20px',
      borderWidth: 1,
      borderColor: isValidTopupNumber ? '#CCCCCC' : theme.colors.optionBorderColor,
      borderRadius: 7,
      alignItems: 'center',
      marginRight: 20,
      marginVertical: 10
    })
  },
  isActive: (status, theme, isDisabled = null) => {
    if (isDisabled) {
      return ({
        backgroundColor: theme.colors.backgroundColor,
      })
    }
    if (status) {
      return ({
        backgroundColor: theme.colors.activeTabColor,
      })
    } else {
      return ({
        backgroundColor: theme.colors.backgroundColor
      })
    }
  },
  isTextActive: (status, theme, isValidTopupNumber) => {
    if (isValidTopupNumber) {
      return (
        { color: isValidTopupNumber ? '#CCCCCC' : '#333333', }
      )
    } else {
      if (status) {
        return ({
          color: theme.colors.tintColor,
        })
      } else {
        return ({
          color: theme.colors.textColorEight,
        })
      }
    }
  },
  valueNumber: {
    fontSize: 32,
    fontWeight: 600,
  }
});
